import * as Yup from 'yup';
import { v4 as uuidV4 } from 'uuid';
import { ICommodity } from '../commodity/commodity';
import { IOptionType } from '@zz2/zz2-ui';
import { IColour } from './colour';
import { IColourFormValues } from './colourFormValues';
import { IColourUpsert } from './colourUpsert';
import OptionType from '../../optionType';

export default class ColourModelHelper {
    public static createFormValues = (
        colour : IColour | null,
        commodities : Array<ICommodity>,
        defaultCommodity : ICommodity | null
    ) : IColourFormValues => {
        if (!colour) return {
            id: 0,
            guid: uuidV4(),
            code: '',
            name: '',
            commodities: defaultCommodity
                ? [OptionType.fromDataModel(defaultCommodity)]
                : [],
            isActive: true,
        };

        const commoditiesOptions = commodities
            .filter(x => x.isActive && colour.commodityIds.includes(x.id))
            .map(OptionType.fromDataModel);

        return {
            id: colour.id,
            guid: colour.guid,
            code: colour.code,
            name: colour.name,
            commodities: commoditiesOptions,
            isActive: colour.isActive,
        };
    };

    public static createUpsert = (formValues : IColourFormValues) : IColourUpsert => {
        return {
            id: formValues.id,
            guid: formValues.guid,
            code: formValues.code,
            name: formValues.name,
            commodityIds: formValues.commodities.map(x => Number(x.value)),
            isActive: formValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<IColourFormValues> => Yup.object().shape({
        id: Yup.number().typeError('Please enter a number.').required('Required'),
        guid: Yup.string().required('Required'),
        code: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        name: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        commodities: Yup.array<IOptionType>().defined().required('Required'),
        isActive: Yup.boolean().required('Required'),
    });
}
